export default __webpack_public_path__ + "static/media/TESTIMONI-FENY SASMITA.bfa6cf28.jpg";